import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Mail, Linkedin, Award, Briefcase, GraduationCap, Globe, MessageSquare, Phone, Calendar, ChevronRight } from 'lucide-react';
interface OurTeamProps {
  onBack?: () => void;
  onNavigate?: (page: 'contact') => void;
}
const teamMembers = [{
  id: 1,
  name: 'Dr. Ahmed Al Busaidi',
  nameAr: 'د. أحمد البوسعيدي',
  title: 'Chief Technology Architect',
  titleAr: 'كبير مهندسي التكنولوجيا',
  image: 'https://ui-avatars.com/api/?name=Ahmed+Al+Busaidi&background=006847&color=fff&size=512&font-size=0.33',
  expertise: ['Microservices Architecture', 'Cloud Computing', 'System Design'],
  experience: '20+ years',
  education: 'PhD in Computer Science, Imperial College London',
  certifications: ['AWS Solutions Architect', 'TOGAF Certified', 'Microsoft Azure Expert'],
  bio: 'Leading technology strategist with extensive experience in designing and implementing enterprise-scale IT solutions across the GCC region.',
  email: 'ahmed.albusaidi@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 2,
  name: 'Fatima Al Lawati',
  nameAr: 'فاطمة اللواتية',
  title: 'Cybersecurity Director',
  titleAr: 'مديرة الأمن السيبراني',
  image: 'https://ui-avatars.com/api/?name=Fatima+Al+Lawati&background=C8102E&color=fff&size=512&font-size=0.33',
  expertise: ['Cybersecurity', 'Risk Management', 'Compliance'],
  experience: '15+ years',
  education: 'MSc Cybersecurity, University of Oxford',
  certifications: ['CISSP', 'CISM', 'CEH', 'ISO 27001 Lead Auditor'],
  bio: 'Expert in cybersecurity strategy and implementation, specializing in protecting critical infrastructure and ensuring regulatory compliance.',
  email: 'fatima.allawati@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 3,
  name: 'Khalid Al Hashmi',
  nameAr: 'خالد الهاشمي',
  title: 'Solutions Architect',
  titleAr: 'مهندس الحلول',
  image: 'https://ui-avatars.com/api/?name=Khalid+Al+Hashmi&background=D4AF37&color=fff&size=512&font-size=0.33',
  expertise: ['Enterprise Architecture', 'Digital Transformation', 'API Design'],
  experience: '18+ years',
  education: 'MSc Information Systems, Stanford University',
  certifications: ['TOGAF 9 Certified', 'AWS Certified', 'Salesforce Architect'],
  bio: 'Specializes in designing comprehensive IT solutions that align with business objectives and drive digital innovation.',
  email: 'khalid.alhashmi@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 4,
  name: 'Sara Al Hinai',
  nameAr: 'سارة الحناوية',
  title: 'DevOps Lead',
  titleAr: 'قائدة DevOps',
  image: 'https://ui-avatars.com/api/?name=Sara+Al+Hinai&background=006847&color=fff&size=512&font-size=0.33',
  expertise: ['DevOps', 'CI/CD', 'Infrastructure Automation'],
  experience: '12+ years',
  education: 'BSc Computer Engineering, Sultan Qaboos University',
  certifications: ['Kubernetes Administrator', 'Docker Certified', 'Jenkins Expert'],
  bio: 'Passionate about automation and continuous delivery, implementing cutting-edge DevOps practices for enterprise clients.',
  email: 'sara.alhinai@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 5,
  name: 'Mohammed Al Balushi',
  nameAr: 'محمد البلوشي',
  title: 'Cloud Infrastructure Manager',
  titleAr: 'مدير البنية التحتية السحابية',
  image: 'https://ui-avatars.com/api/?name=Mohammed+Al+Balushi&background=C8102E&color=fff&size=512&font-size=0.33',
  expertise: ['Cloud Architecture', 'AWS', 'Azure', 'Infrastructure Management'],
  experience: '14+ years',
  education: 'MSc Cloud Computing, University of Manchester',
  certifications: ['AWS Solutions Architect Professional', 'Azure Solutions Architect', 'Google Cloud Professional'],
  bio: 'Expert in cloud migration and optimization strategies, helping organizations maximize their cloud investments.',
  email: 'mohammed.albalushi@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 6,
  name: 'Aisha Al Kalbani',
  nameAr: 'عائشة الكلباني',
  title: 'Security Consultant',
  titleAr: 'مستشارة أمنية',
  image: 'https://ui-avatars.com/api/?name=Aisha+Al+Kalbani&background=006847&color=fff&size=512&font-size=0.33',
  expertise: ['Penetration Testing', 'Security Auditing', 'Threat Analysis'],
  experience: '10+ years',
  education: 'BSc Information Security, King\'s College London',
  certifications: ['CEH', 'OSCP', 'GPEN', 'Security+'],
  bio: 'Specialized in identifying and mitigating security vulnerabilities through comprehensive testing and analysis.',
  email: 'aisha.alkalbani@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 7,
  name: 'Rashid Al Amri',
  nameAr: 'راشد العامري',
  title: 'IT Governance Specialist',
  titleAr: 'متخصص حوكمة تكنولوجيا المعلومات',
  image: 'https://ui-avatars.com/api/?name=Rashid+Al+Amri&background=D4AF37&color=fff&size=512&font-size=0.33',
  expertise: ['IT Governance', 'COBIT', 'Risk Management', 'Compliance'],
  experience: '16+ years',
  education: 'MBA, London Business School',
  certifications: ['CGEIT', 'CRISC', 'COBIT 2019', 'ITIL Expert'],
  bio: 'Helps organizations establish effective IT governance frameworks that ensure compliance and drive business value.',
  email: 'rashid.alamri@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}, {
  id: 8,
  name: 'Layla Al Zadjali',
  nameAr: 'ليلى الزدجالي',
  title: 'Business Analyst Lead',
  titleAr: 'قائدة محللي الأعمال',
  image: 'https://ui-avatars.com/api/?name=Layla+Al+Zadjali&background=C8102E&color=fff&size=512&font-size=0.33',
  expertise: ['Business Analysis', 'Requirements Management', 'Process Optimization'],
  experience: '11+ years',
  education: 'MSc Business Analytics, University of Cambridge',
  certifications: ['CBAP', 'PMI-PBA', 'Six Sigma Black Belt'],
  bio: 'Bridges the gap between business needs and technology solutions through detailed analysis and strategic planning.',
  email: 'layla.alzadjali@bareeqtech.net',
  linkedin: 'https://bareeqtech.net'
}];
const departments = [{
  name: 'All Team',
  count: teamMembers.length
}, {
  name: 'Architecture',
  count: 3
}, {
  name: 'Security',
  count: 2
}, {
  name: 'DevOps',
  count: 1
}, {
  name: 'Governance',
  count: 2
}];
export default function OurTeam({
  onBack,
  onNavigate
}: OurTeamProps) {
  const [selectedDepartment, setSelectedDepartment] = useState('All Team');
  const [selectedMember, setSelectedMember] = useState<typeof teamMembers[0] | null>(null);

  // Filter team members based on selected department
  const filteredMembers = teamMembers.filter(member => {
    if (selectedDepartment === 'All Team') return true;

    // Map department names to relevant expertise/titles
    switch (selectedDepartment) {
      case 'Architecture':
        return member.expertise.some(exp => exp.toLowerCase().includes('architecture') || exp.toLowerCase().includes('cloud') || exp.toLowerCase().includes('system design')) || member.title.toLowerCase().includes('architect');
      case 'Security':
        return member.expertise.some(exp => exp.toLowerCase().includes('security') || exp.toLowerCase().includes('cybersecurity') || exp.toLowerCase().includes('risk')) || member.title.toLowerCase().includes('security');
      case 'DevOps':
        return member.expertise.some(exp => exp.toLowerCase().includes('devops') || exp.toLowerCase().includes('ci/cd') || exp.toLowerCase().includes('automation')) || member.title.toLowerCase().includes('devops');
      case 'Governance':
        return member.expertise.some(exp => exp.toLowerCase().includes('governance') || exp.toLowerCase().includes('compliance') || exp.toLowerCase().includes('business analysis')) || member.title.toLowerCase().includes('governance') || member.title.toLowerCase().includes('business analyst');
      default:
        return true;
    }
  });
  return <div className="min-h-screen bg-gray-50">
      {/* Header with Back Button */}
      <div className="bg-white border-b sticky top-0 z-10">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <button onClick={onBack} className="flex items-center gap-2 text-gray-600 hover:text-[#006847] transition-colors">
            <ArrowLeft size={20} />
            <span className="font-medium">Back to Home</span>
          </button>
        </div>
      </div>

      {/* Hero Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#006847] to-[#004d35] text-white">
        <div className="max-w-7xl mx-auto px-4">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Meet Our Expert Team
            </h1>
            <p className="text-xl text-white/90 mb-6">
              فريق الخبراء لدينا
            </p>
            <p className="text-lg text-white/80">
              Our team of highly skilled IT professionals brings decades of combined experience 
              in technology consulting, cybersecurity, and digital transformation.
            </p>
          </motion.div>
        </div>

        {/* Decorative Wave */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 48h1440V0c-240 48-480 48-720 24C480 0 240 0 0 24v24z" fill="#F9FAFB" />
          </svg>
        </div>
      </section>

      {/* Department Filter */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex gap-4 overflow-x-auto pb-2">
            {departments.map(dept => <button key={dept.name} onClick={() => setSelectedDepartment(dept.name)} className={`px-6 py-3 rounded-full font-medium whitespace-nowrap transition-colors ${selectedDepartment === dept.name ? 'bg-[#006847] text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`}>
                {dept.name} ({dept.count})
              </button>)}
          </div>
        </div>
      </section>

      {/* Team Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {filteredMembers.map((member, index) => <motion.div key={member.id} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.05
          }} className="bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all cursor-pointer group" onClick={() => setSelectedMember(member)}>
                <div className="relative aspect-square overflow-hidden">
                  <img src={member.image} alt={member.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-end justify-center p-6">
                    <button className="bg-white text-[#006847] px-6 py-2 rounded-full font-semibold flex items-center gap-2">
                      View Profile
                      <ChevronRight size={18} />
                    </button>
                  </div>
                </div>

                <div className="p-6">
                  <div className="flex items-center gap-2 text-xs text-[#006847] font-medium mb-2">
                    <Briefcase size={14} />
                    <span>{member.experience}</span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-800 mb-1">
                    {member.name}
                  </h3>
                  <p className="text-sm text-gray-500 mb-2">{member.nameAr}</p>
                  <p className="text-gray-600 mb-4">{member.title}</p>

                  <div className="flex flex-wrap gap-2 mb-4">
                    {member.expertise.slice(0, 2).map((skill, i) => <span key={i} className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full">
                        {skill}
                      </span>)}
                  </div>

                  <div className="flex items-center gap-3 pt-4 border-t">
                    <button onClick={e => {
                  e.stopPropagation();
                  onNavigate?.('contact');
                }} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#006847] hover:text-white transition-colors">
                      <Mail size={18} />
                    </button>
                    <a href={member.linkedin} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center hover:bg-[#006847] hover:text-white transition-colors" onClick={e => e.stopPropagation()}>
                      <Linkedin size={18} />
                    </a>
                  </div>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Member Detail Modal */}
      {selectedMember && <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setSelectedMember(null)}>
          <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="grid md:grid-cols-2 gap-8 p-8">
              <div>
                <img src={selectedMember.image} alt={selectedMember.name} className="w-full aspect-square object-cover rounded-2xl mb-6" />
                
                <div className="space-y-4">
                  <div>
                    <h4 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                      <GraduationCap size={18} className="text-[#006847]" />
                      Education
                    </h4>
                    <p className="text-gray-600">{selectedMember.education}</p>
                  </div>

                  <div>
                    <h4 className="font-semibold text-gray-700 mb-2 flex items-center gap-2">
                      <Award size={18} className="text-[#006847]" />
                      Certifications
                    </h4>
                    <div className="flex flex-wrap gap-2">
                      {selectedMember.certifications.map((cert, i) => <span key={i} className="text-xs bg-[#006847]/10 text-[#006847] px-3 py-1 rounded-full">
                          {cert}
                        </span>)}
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <button onClick={() => setSelectedMember(null)} className="text-gray-400 hover:text-gray-600 mb-4">
                  ✕ Close
                </button>

                <h2 className="text-3xl font-bold text-gray-800 mb-2">
                  {selectedMember.name}
                </h2>
                <p className="text-lg text-gray-500 mb-1">{selectedMember.nameAr}</p>
                <p className="text-xl text-[#006847] font-medium mb-6">
                  {selectedMember.title}
                </p>

                <p className="text-gray-600 mb-6">{selectedMember.bio}</p>

                <div className="mb-6">
                  <h4 className="font-semibold text-gray-700 mb-3">Areas of Expertise</h4>
                  <div className="flex flex-wrap gap-2">
                    {selectedMember.expertise.map((skill, i) => <span key={i} className="bg-gray-100 text-gray-700 px-4 py-2 rounded-lg">
                        {skill}
                      </span>)}
                  </div>
                </div>

                <div className="space-y-3 pt-6 border-t">
                  <a href={`mailto:${selectedMember.email}`} className="flex items-center gap-3 text-gray-600 hover:text-[#006847] transition-colors">
                    <Mail size={20} />
                    <span>{selectedMember.email}</span>
                  </a>
                  <a href={selectedMember.linkedin} className="flex items-center gap-3 text-gray-600 hover:text-[#006847] transition-colors">
                    <Linkedin size={20} />
                    <span>LinkedIn Profile</span>
                  </a>
                </div>

                <button className="w-full mt-6 bg-[#006847] text-white py-3 rounded-full font-semibold hover:bg-[#005438] transition-colors flex items-center justify-center gap-2" onClick={() => onNavigate?.('contact')}>
                  <Calendar size={20} />
                  Schedule Meeting
                </button>
              </div>
            </div>
          </motion.div>
        </div>}

      {/* Join Our Team CTA */}
      <section className="py-16 bg-gradient-to-r from-[#006847] to-[#004d35] text-white">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }}>
            <h2 className="text-3xl md:text-4xl font-bold mb-4">
              Join Our Team
            </h2>
            <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
              We're always looking for talented IT professionals to join our growing team
            </p>
            <button className="bg-[#C8102E] hover:bg-[#a80d26] text-white px-8 py-4 rounded-full font-semibold transition-colors inline-flex items-center gap-2" onClick={() => onNavigate?.('contact')}>
              View Open Positions
              <ChevronRight size={20} />
            </button>
          </motion.div>
        </div>
      </section>
    </div>;
}